import { useMutation } from '@tanstack/react-query';
import type { CandidateEndpointBulkWithdrawPostRequest } from '../types/CandidateProfile';

export default function usePostCandidateEndpointBulkWithdraw() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, ids }: CandidateEndpointBulkWithdrawPostRequest) => {
      const response = await fetch(
        `/agent/api/candidate_endpoints/${candidateProfileId}/bulk_withdraw`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ ids }),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
